var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoodle9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-10 h-10",
    viewBox: "0 0 64 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.23255 26.7514C15.223 15.9596 30.4602 1.60032 47.8878 1.49885C57.831 1.44095 62.3752 9.78586 62.1744 18.7665C61.6849 40.6647 40.0446 61.7548 23.9005 73.8677C19.9471 76.8339 13.5467 81.611 8.07588 81.2786C0.420381 80.8136 1.36459 71.6772 3.3299 66.6796C7.85072 55.1836 19.929 48.1049 30.5601 43.0414C34.7906 41.0264 33.7432 41.0995 30.2331 43.1597C22.7334 47.5614 15.3015 53.3484 9.53032 59.8602C7.56937 62.0728 -0.791668 74.7232 8.38903 73.572C14.7531 72.774 20.361 65.0349 23.4272 60.0863C25.6661 56.473 29.1774 46.5873 20.929 51.5795C18.5939 52.9928 3.81875 65.169 8.65002 69.3099C14.5843 74.3962 27.2148 60.5269 30.0591 56.6593C38.2422 45.5318 24.1537 52.5612 20.0139 56.9828C18.144 58.98 9.33267 77.0239 16.5658 70.4163C19.588 67.6555 22.9832 63.5629 23.9109 59.4601C24.7782 55.6238 21 53.4993 18.0063 55.7651C13.8131 58.9386 13.8495 64.7563 15.3201 69.0246",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoodle9);
export default __webpack_public_path__ + "static/media/Doodle9.614cecd81e76d253c395a758b86826f3.svg";
export { ForwardRef as ReactComponent };